import { Badge } from '@/components/ui/badge';
import { Avatar, AvatarImage, AvatarFallback } from '@/components/ui/avatar';
import { Project } from '@/types/project';

interface ProjectCompactHeaderProps {
  project: Project;
}

const ProjectCompactHeader = ({ project }: ProjectCompactHeaderProps) => {
  const statusColors = {
    intake: 'bg-blue-500',
    tender: 'bg-orange-500', 
    build: 'bg-green-500',
    defects: 'bg-red-500',
    archive: 'bg-gray-500',
    service: 'bg-purple-500',
    inactive: 'bg-gray-400'
  };

  const statusLabels = {
    intake: 'Tiếp nhận',
    tender: 'Đấu thầu',
    build: 'Thi công', 
    defects: 'Khắc phục',
    archive: 'Lưu trữ',
    service: 'Bảo trì',
    inactive: 'Không hoạt động'
  };

  return (
    <div className="flex items-center gap-2 flex-wrap md:flex-shrink-0">
      <Avatar className="h-8 w-8 flex-shrink-0 rounded-lg border border-border/60 shadow-sm overflow-hidden bg-white">
        <AvatarImage src={project.image_url || undefined} fallbackName={project.project_name} className="object-contain p-0.5" />
        <AvatarFallback className="text-xs font-semibold">
          {project.project_name?.[0]?.toUpperCase() || 'P'}
        </AvatarFallback>
      </Avatar>
      <h1 className="text-lg md:text-xl font-bold truncate max-w-[250px] md:max-w-[400px]">
        {project.project_name}
      </h1>
      <Badge 
        className={`${statusColors[project.status]} text-white text-xs px-2 py-0.5 flex-shrink-0`}
      >
        {statusLabels[project.status]}
      </Badge>
    </div>
  );
};

export default ProjectCompactHeader;
